import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Bandeira } from '../shared/models/bandeira.enum';
import BrowserUtils from '../shared/utils/browser-utils';
import { AutenticacaoService } from './autenticacao.service';

@Injectable({
  providedIn: 'root'
})
export class HttpAutenticacaoIntercept {

  constructor(
    private autenticacaoService: AutenticacaoService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.autenticacaoService.token;
    const autenticacao = this.autenticacaoService.autenticacao;

    const headers: { [name: string]: string | string[]; } = {};

    if (this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA && !BrowserUtils.isOldFirefox()) {
      headers.apiKey = environment.apiKeyCB;
    } else if (this.autenticacaoService.bandeira === Bandeira.PONTOFRIO && !BrowserUtils.isOldFirefox()) {
      headers.apiKey = environment.apiKeyPF;
    }

    if (autenticacao) {
      if (autenticacao.parceiro) {
        headers['x-token-parceiro'] = autenticacao.parceiro;
      }

      if (autenticacao.identificacaoLog) {
        headers['x-request-id'] = autenticacao.identificacaoLog;
      }

    }

    headers['x-bandeira'] = autenticacao?.bandeira || this.autenticacaoService.bandeira;


    if (token) {
      if (BrowserUtils.isOldFirefox()) {
        headers.Authorization = `Bearer ${token}`;
      } else {
        headers['x-authentication-token'] = `Bearer ${token}`;
      }
    }

    return next.handle(req.clone({ setHeaders: headers }));
  }

}
